import { Address } from "./getAddressDetails";

export function formatAddress(address: Partial<Address>): string {
  const { address: streetAddress, postalCode, city } = address;
  return [streetAddress, [postalCode, city].filter(Boolean).join(" ")].filter(Boolean).join(", ");
}
